import React from 'react';
import {useTranslation} from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from './assessmentInfoCard.module.scss';

export function AssessmentInfoCard() {
    const {t} = useTranslation(); 
    return (
        <div className={styles.container}>
            <InfoOutlinedIcon />
            <p className={styles.text}>
                {t('ACCOUNTS_PAGE.ASSESSMENT_DISCLAIMER')}
            </p>
        </div>
    );
}
